import { isEmpty } from 'lodash';
import React from 'react';
import { color, font, type } from 'common/tokens';

const styles = {
  questionLabelContainer: {
    paddingBottom: 8,
  },
  questionLabel: {
    ...type.body,
    fontWeight: font.MEDIUM,
    color: color.TEXT,
  },
};

const QuestionLabel = (props) => {
  const { label, mandatory, labelStyling = {}, labelSpacing = {}, inputId } = props;

  const mergedLabelStyles = { ...styles.questionLabel, ...labelStyling };

  return (
    <div style={{ ...styles.questionLabelContainer, ...labelSpacing }}>
      {!isEmpty(label) && (
        <label htmlFor={inputId} style={mergedLabelStyles}>
          {label} {mandatory ? <span style={{ color: color.DANGER }} aria-hidden={true}>*</span> : ""}
        </label>
      )}
    </div>
  );
};

export default QuestionLabel;
